import { render, staticRenderFns } from "./ActualCalculation.vue?vue&type=template&id=fca06520&scoped=true"
import script from "./ActualCalculation.vue?vue&type=script&setup=true&lang=js"
export * from "./ActualCalculation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ActualCalculation.vue?vue&type=style&index=0&id=fca06520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca06520",
  null
  
)

export default component.exports